import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(SplitText);

const scrollSmootherInstance = new ScrollSmoother({
  wrapper: '[data-scroll-smoother="wrapper"]',
  content: '[data-scroll-smoother="content"]',
  smooth: 0.5,
  smoothTouch: 0.1,
  // normalizeScroll: true,
  ignoreMobileResize: true,
});

export { gsap, ScrollTrigger, ScrollSmoother, SplitText, scrollSmootherInstance };
